'use strict';

const { h } = require('phy');

const Carousel = require('../../../components/carousel');
const SidebarBrowseLetter = require('../../merchant/views/sidebar-browse-letter');
const EmailSubscription = require('../../email_subscription/views/email-subscription');

const { pruneData } = require('../../support/prune-data');

function SideBar({ advertsForCarousel, routes, csrfToken, isTouch }) {
  return [
    Carousel({
      routes: pruneData(routes, 'merchant:show'),
      items: advertsForCarousel,
      isTouch,
    }),
    h(SidebarBrowseLetter, { routes }),
    EmailSubscription({
      csrfToken,
      routes,
      bhwName: 'EmailSubscription',
    }),
  ];
}

module.exports = SideBar;
